import { useEffect, useState } from 'react'
import api from '@/services/api'

// Una sola petición por sesión: la lista de países cambia muy poco y la piden varias pantallas.
let cache = null
let enCurso = null

/**
 * Países cd-2b según la API, con su estado (`operativo` | `demo` | `roadmap`). Sin respaldo
 * estático: si la API falla, `error` lo dice y la pantalla no ofrece países que quizá no se venden.
 */
export function usePaises() {
  const [estado, setEstado] = useState({ paises: cache || [], cargando: !cache, error: null })

  useEffect(() => {
    if (cache) return undefined
    let vivo = true
    enCurso = enCurso || api.get('/public/cd2b/paises').then((r) => r.data?.data || [])
    enCurso
      .then((paises) => {
        cache = paises
        if (vivo) setEstado({ paises, cargando: false, error: null })
      })
      .catch(() => {
        enCurso = null
        if (vivo) setEstado({ paises: [], cargando: false, error: 'No se pudo cargar la lista de países.' })
      })
    return () => { vivo = false }
  }, [])

  return estado
}

/** Solo los países donde se puede vender hoy (no los que están en hoja de ruta). */
export const vendibles = (paises) => paises.filter((p) => p.estado !== 'roadmap')
